var React = require('react');

function Default (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.35917 27.8571C11.0801 27.8571 14.3876 25.7862 14.3876 21.6443C14.3876 17.8859 11.5762 16.0451 8.35142 16.0451C7.77261 16.0451 7.11111 16.1218 6.44961 16.3519C6.69767 13.8974 8.76486 10.2924 14.6357 7.83797L13.3127 5C4.46512 7.45446 0 14.1275 0 19.5733C0 24.6357 2.56331 27.8571 7.35917 27.8571ZM24.7235 27.8571C28.4444 27.8571 31.7519 25.7862 31.7519 21.6443C31.7519 17.8859 28.9406 16.0451 25.7158 16.0451C25.1369 16.0451 24.4755 16.1218 23.814 16.3519C24.062 13.8974 26.1292 10.2924 32 7.83797L30.677 5C21.8295 7.45446 17.3643 14.1275 17.3643 19.5733C17.3643 24.6357 19.9276 27.8571 24.7235 27.8571Z","fill":"#056BFE"}));
}

Default.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Default;

Default.default = Default;
